import(/* webpackMode: "eager" */ "/app/src/app/company/careers/web-security-consultant/page.tsx");
